// extracted by mini-css-extract-plugin
module.exports = {"errorMsgContainer":"ErrorMsg_errorMsgContainer__11I4a","errorMsgSupport":"ErrorMsg_errorMsgSupport__h_-d_","firstLine":"ErrorMsg_firstLine__2VTlL"};